import { Component } from "react"

/* Components */
import { Process, Transaction, Cards, Notes, InnerLayout } from "../../components"

/* Widgets */
import RoundStat from "../Round/RoundStat"
import RoundRefunds from "../Round/RoundRefunds"
import ElectronPayment from "./Payment"

/* REST API */
import { game as gameInfo, endGame, credit } from "../../api/Electron"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* Icons */
import {
    SpadeIcon, HashIcon, TagIcon, ClockIcon, FlagIcon, PlayerIcon, DebitIcon, CreditIcon,
    NetIcon, BalanceIcon, ReceiptIcon, RefundIcon, PayIcon, StopIcon, CardsIcon, ArrowIcon, WarningIcon, EyeOffIcon,
} from "../../components/Icons"

/* Moment */
import "moment/locale/ru"


/* Widget ElectronGameInformation — the round card of any electron game */
class ElectronGameInformation extends Component {

    constructor() {
        super()

        this.state = {
            table: null,
            data: null,
            transactions: [],
            gameProcess: [],
            results: [],
            cards: [],
            status: "loading",
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Game Information */
    load = (reload = false) => {

        /* Fields */
        const { uid, gameID, game } = this.props

        /* Validate */
        if (!uid || !gameID || !game) {
            this.setState({ status: "error", data: null })
            return
        }

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send request to REST API */
        gameInfo(game.key, { uid, gameID }).then((response) => {
            if (response.status === 200) {
                this.setState({
                    status: "ok",
                    data: response.data.game,
                    table: response.data.table,
                    transactions: response.data.transactions,
                    gameProcess: response.data.gameProcess,
                    cards: response.data.cards,
                    results: response.data.results,
                })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null, table: null })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null, table: null })
            }
            else {
                this.setState({ status: "error", data: null, table: null })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, table: null })
        })

    }

    /* Get Result — games that deal several boxes per round also match the box */
    getResult = (type, box) => {

        const { results } = this.state
        const { game } = this.props

        if (results && Array.isArray(results) && results.length > 0) {
            const index = results.findIndex((e) => e.type === type && (!game.boxes || parseInt(e.box) === parseInt(box)))
            if (index > -1) {
                return results[index]
            }
        }

        return null
    }


    /* Get Cards — games that deal several boxes per round also match the box */
    getCards = (type, box) => {

        /* Fields */
        const { cards } = this.state
        const { game } = this.props

        const list = []

        if (cards && Array.isArray(cards) && cards.length > 0) {
            cards.forEach((card) => {
                if (card.type === type && (!game.boxes || parseInt(card.box) === parseInt(box))) {
                    list.push(card)
                }
            })
        }

        return list
    }


    /* Currency Of The Round — every transaction of a round carries the same one */
    getCurrency = () => {

        /* Fields */
        const { transactions } = this.state

        let currency = "USD"

        if (transactions && Array.isArray(transactions) && transactions.length > 0) {
            transactions.forEach((transaction) => {
                currency = transaction.currency
            })
        }

        return currency
    }


    /* BALANCE CALCULATION */
    calculateBalance = () => {

        const { data, transactions } = this.state

        if (data && data.startBalance) {

            let endBalance = parseFloat(data.startBalance)
            let debit = 0
            let credit = 0
            let total = 0

            if (transactions && Array.isArray(transactions) && transactions.length > 0) {
                transactions.forEach((transaction) => {
                    if (parseInt(transaction.status) === 1) {

                        if (transaction.type === "credit") {
                            endBalance = endBalance + parseFloat(transaction.total)
                            credit = credit + parseFloat(transaction.total)
                            total = total - parseFloat(transaction.total)
                        }

                        if (transaction.type === "debit") {
                            endBalance = endBalance - parseFloat(transaction.total)
                            debit = debit + parseFloat(transaction.total)
                            total = total + parseFloat(transaction.total)
                        }

                    }
                })
            }

            return {
                debit: utils.convertor(parseFloat(debit), data.symbol),
                credit: utils.convertor(parseFloat(credit), data.symbol),
                total: utils.convertor(parseFloat(total), data.symbol),
                startBalance: utils.convertor(parseFloat(data.startBalance), data.symbol),
                endBalance: parseInt(data.status) === 1 ? utils.convertor(endBalance, data.symbol) : "-",
            }

        }

        return { startBalance: "-", endBalance: "-", total: "-", debit: "-", credit: "-" }
    }



    /* End Game */
    end = (refund = false) => {

        /* Fields */
        const { data, transactions } = this.state
        const { uid, game } = this.props

        /* Check Status */
        if (parseInt(data.status) === 1) {
            return
        }

        const currency = this.getCurrency()

        Swal.fire({
            title: t("widget.finishConfirm"),
            text: t("widget.finishWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.finishButton"),
            cancelButtonText: t("common.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {

                /* With Refund */
                if (refund) {

                    let debit = 0

                    if (transactions && Array.isArray(transactions) && transactions.length > 0) {
                        transactions.forEach((transaction) => {
                            if (parseInt(transaction.status) === 1 && transaction.type === "debit") {
                                debit = debit + parseFloat(transaction.total)
                            }
                        })
                    }

                    const refunded = data.refund ? parseFloat(data.refund) : 0
                    const total = debit - refunded

                    if (total > 0) {
                        credit(game.key, { uid, type: "refund", refund: total, currency, playerID: data.player, roundId: data.roundId, id: data.id }).then((creditRes) => {
                            if (creditRes.status === 200) {
                                this.close(currency, total)
                            }
                            else {
                                this.load()
                                Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                            }
                        }).catch(() => {
                            this.load()
                            Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                        })
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                    }

                }
                else {
                    this.close()
                }
            }
        })
    }


    /* Close The Round On The Game Server */
    close = (currency = null, total = 0) => {

        /* Fields */
        const { data } = this.state
        const { socket, uid, game } = this.props

        /* END GAME */
        endGame(game.key, { uid, gameID: data.id }).then((response) => {
            if (response.status === 200) {
                if (response.data.updated === "yes") {

                    /* The game server hears about it only when this round is still the live one —
                       an old round must never end the game that is running now */
                    if (socket && response.data.live !== "no") {
                        socket.emit("end", { playerID: data.player, gameID: data.id })

                        if (currency) {
                            socket.emit("adminNotification", { type: "refund", title: "Return of funds", total, currency, playerID: data.player, gameID: data.id })
                        }
                    }

                    Swal.fire(utils.notification(t("widget.finishSuccess"), "success", 3000))
                    this.load(true)
                }
                else {
                    Swal.fire(utils.notification(t("widget.alreadyFinished"), "error", 3000))
                }
            }
            else {
                Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
        })

    }


    /* Open The Payment Modal — it lives behind its own ref */
    payment = (type) => {

        /* Fields */
        const { data, gameProcess } = this.state

        /* Check Modal */
        if (!this._payment) {
            return
        }

        this._payment.open({ type, data, balance: this.calculateBalance(), gameProcess, currency: this.getCurrency() })
    }


    /* Process Box Count — a fixed number, or the boxes that really took part in the round */
    getProcessCount = () => {

        const { gameProcess } = this.state
        const { game } = this.props

        if (game.process !== "boxes") {
            return game.process
        }

        let count = 0

        if (gameProcess && Array.isArray(gameProcess) && gameProcess.length > 0) {
            gameProcess.forEach((process) => {
                if (process.type === "ante" && parseFloat(process.total) > 0) {
                    count = count + 1
                }
            })
        }

        return count
    }


    /* Draw One Card Row */
    _cards = (row, index) => {

        /* Fields */
        const { game } = this.props
        const cards = this.getCards(row.type, row.box)

        /* Some games only deal a row in part of the rounds */
        if (game.hideEmpty && cards.length === 0) {
            return null
        }

        return <Cards key={`${index}`} title={row.title} cards={cards} result={row.result ? this.getResult(row.type, row.box) : undefined} />
    }


    /* Draw The Cards Of The Round */
    _cardsContainer = () => {

        /* Fields */
        const { game } = this.props
        const { data } = this.state

        /* THE HAND OF A LIVE ROUND STAYS CLOSED — the cards come with the end of the round or with its pause */
        if (parseInt(data.status) !== 1 && parseInt(data.isPaused) !== 1) {
            return <div className="rnd--cards-hidden"><EyeOffIcon size={16} />{t("round.cardsHidden")}</div>
        }

        /* Rows drawn together, and the ones that get their own container below */
        const rows = game.cards.filter((row) => !row.container)
        const additional = game.cards.filter((row) => row.container === "additional")

        return (
            <>
                <div className="cards--container">
                    {rows.map((row, index) => this._cards(row, index))}
                </div>

                {additional.length > 0 &&
                    <div className="cards--container additional">
                        {additional.map((row, index) => this._cards(row, index))}
                    </div>
                }
            </>
        )
    }


    /* THE FAILED AND THE HANGING TRANSACTIONS OF THE ROUND */
    getProblem = () => {

        /* Fields */
        const { data } = this.state

        /* Fields */
        const failed = parseInt(data.failed) > 0 ? parseInt(data.failed) : 0
        const pending = parseInt(data.pending) > 0 ? parseInt(data.pending) : 0

        /* Check Counters */
        if (failed === 0 && pending === 0) {
            return null
        }

        /* A Failure Outweighs A Hanging Request */
        return {
            tone: failed > 0 ? "failed" : "pending",
            count: failed + pending,
            hint: [
                failed > 0 ? `${t("gtx.failed")}: ${failed}` : "",
                pending > 0 ? `${t("gtx.pending")}: ${pending}` : "",
            ].filter((part) => part).join(" · "),
        }
    }

    /* Open The Refunds Of The Round */
    openRefunds = () => {

        /* Fields */
        const { uid } = this.props
        const { data } = this.state

        /* Check Modal */
        if (!this._refunds || !data) {
            return
        }

        this._refunds.open({ uid, round: data.roundId })
    }

    /* Draw The Head Of The Round */
    _hero = () => {

        /* Fields */
        const { table, data } = this.state

        /* Fields */
        const datetime = utils.getTime(data.createdAt)
        const balance = this.calculateBalance()
        const problem = this.getProblem()

        return (
            <div className="rnd--hero">

                <div className="rnd--hero-main">

                    <div className="rnd--hero-round">#{data.number}</div>

                    <div className="rnd--hero-text">
                        <h3>{table.name}</h3>
                        <p><ClockIcon size={11} />{datetime.time}, {datetime.date}</p>
                    </div>

                </div>

                <div className="rnd--hero-badges">

                    {parseInt(data.status) === 1
                        ? <div className="rnd--badge blue">{t("widget.completed")}</div>
                        : <div className="rnd--badge violet">{t("widget.notCompleted")}</div>
                    }

                    {/* The money of the round never went through */}
                    {problem &&
                        <div className={`rnd--badge ${problem.tone}`} title={problem.hint}>
                            <WarningIcon size={11} />
                            {t("round.problem")} {problem.count}
                        </div>
                    }

                </div>

                <div className="rnd--hero-money">

                    <div className="rnd--hero-money-row">
                        <span>CREDIT</span>
                        <p>{balance.credit}</p>
                    </div>

                    <div className="rnd--hero-money-row">
                        <span>DEBIT</span>
                        <p>{balance.debit}</p>
                    </div>

                    <div className="rnd--hero-net">
                        <span>{t("widget.total")}</span>
                        <p>{balance.total}</p>
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { status, table, data, transactions, gameProcess } = this.state
        const { game, uid, socket } = this.props

        /* Layout */
        if (status !== "ok" || !data || !table) {
            return <InnerLayout status={status === "ok" ? "error" : status} reload={() => this.load(true)} />
        }

        /* Fields */
        const datetime = utils.getTime(data.createdAt)
        const balance = this.calculateBalance()
        const processCount = this.getProcessCount()
        const done = parseInt(data.status) === 1

        return (
            <div className="rnd">

                {/* Draw Hero */}
                {this._hero()}

                <div className="rnd--grid">

                    {/* WHAT THE ROUND IS */}
                    <div className="rnd--card">

                        <div className="rnd--card-head"><SpadeIcon size={13} />{t("round.about")}</div>

                        <div className="rnd--rows">

                            <RoundStat icon={<SpadeIcon size={14} />} title={t("widget.game")}>{table.name}</RoundStat>

                            <RoundStat icon={<HashIcon size={14} />} title={t("widget.gameNumber2")}>{data.number}</RoundStat>

                            <RoundStat icon={<TagIcon size={14} />} tone="blue" title={t("widget.roundId")}>
                                <span className="rnd--mono">{utils.checkValue(data.roundId, "—")}</span>
                            </RoundStat>

                            <RoundStat icon={<ClockIcon size={14} />} title={t("widget.date")}>
                                {datetime.time}, <span className="rnd--muted">{datetime.date}</span>
                            </RoundStat>

                            <RoundStat icon={<PlayerIcon size={14} />} tone="blue" title={`${t("widget.player")} ${utils.checkValue(data.player, "—")}`}>
                                {utils.checkValue(data.firstName, "—")}
                            </RoundStat>

                            <RoundStat icon={<FlagIcon size={14} />} title={t("widget.gameStatus")}>
                                {done
                                    ? <div className="rnd--badge blue">{t("widget.completed")}</div>
                                    : <div className="rnd--badge violet">{t("widget.notCompleted")}</div>
                                }
                            </RoundStat>

                        </div>

                    </div>

                    {/* WHAT THE ROUND DID TO THE MONEY */}
                    <div className="rnd--card">

                        <div className="rnd--card-head"><ReceiptIcon size={13} />{t("round.money")}</div>

                        <div className="rnd--rows">

                            <RoundStat icon={<DebitIcon size={14} />} tone="green" title="DEBIT">{balance.debit}</RoundStat>

                            <RoundStat icon={<CreditIcon size={14} />} tone="red" title="CREDIT">{balance.credit}</RoundStat>

                            <RoundStat icon={<NetIcon size={14} />} tone="violet" title={t("widget.total")}>{balance.total}</RoundStat>

                            <RoundStat icon={<BalanceIcon size={14} />} title={t("widget.balanceBefore")}>{balance.startBalance}</RoundStat>

                            <RoundStat icon={<BalanceIcon size={14} />} tone="blue" title={t("widget.balanceAfter")}>{balance.endBalance}</RoundStat>

                            {/* Every operation of the round, the refunds of the admins first */}
                            {`${utils.checkValue(data.roundId)}`.trim() === ""
                                ? <div className="rnd--link disabled" title={t("round.noRoundId")}>
                                    <RefundIcon size={13} />
                                    <span>{t("widget.allRefunds")}</span>
                                </div>
                                : <div onClick={() => this.openRefunds()} className="rnd--link">
                                    <RefundIcon size={13} />
                                    <span>{t("widget.allRefunds")}</span>
                                    <ArrowIcon size={12} />
                                </div>
                            }

                        </div>

                    </div>

                    {/* WHAT THE ADMIN CAN STILL DO */}
                    <div className="rnd--card">

                        <div className="rnd--card-head"><FlagIcon size={13} />{t("round.actions")}</div>

                        <div className="rnd--groups">

                            <div className="rnd--group">

                                <div className="rnd--group-title">{t("round.gameActions")}</div>

                                <div className="rnd--buttons">
                                    <div onClick={() => this.end()} className={`rnd--button danger ${done ? "disabled" : ""}`}>
                                        <StopIcon size={13} />{t("widget.finishGame")}
                                    </div>
                                    <div onClick={() => this.end(true)} className={`rnd--button ghost ${done ? "disabled" : ""}`}>
                                        <RefundIcon size={13} />{t("widget.finishAndRefund")}
                                    </div>
                                </div>

                            </div>

                            <div className="rnd--group">

                                <div className="rnd--group-title">{t("round.paymentActions")}</div>

                                <div className="rnd--buttons">
                                    <div onClick={() => this.payment("refund")} className="rnd--button violet">
                                        <RefundIcon size={13} />{t("widget.refundTitle")}
                                    </div>
                                    <div onClick={() => this.payment("payment")} className="rnd--button pink">
                                        <PayIcon size={13} />{t("widget.payTitle")}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* Draw Cards — the cards of the round come before everything the player did */}
                <div className="rnd--cards">
                    <div className="rnd--card-head"><CardsIcon size={13} />{t("round.cards")}</div>
                    {this._cardsContainer()}
                </div>

                {/* Processes */}
                <Process count={processCount} symbol={data.symbol} data={gameProcess} />

                {/* Transactions */}
                <Transaction symbol={data.symbol} data={transactions} />

                {/* Notes */}
                <Notes uid={table.uid} gameID={data.id} />

                {/* Payment Modal */}
                <ElectronPayment ref={(ref) => this._payment = ref} game={game} uid={uid} socket={socket} apply={() => this.load()} />

                {/* Draw Refunds */}
                <RoundRefunds ref={(ref) => this._refunds = ref} />

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps)(ElectronGameInformation)
